var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"AccountDownloads"}},[_c('Page',{attrs:{"title":_vm.$t('Downloads'),"size":"fullWidth"}},[_c('Layout',[_c('LayoutSection',[_c('Card',[_c('Filters',{ref:"filters",attrs:{"filters":[
                {
                  key: 'fromDate',
                  label: _vm.$t('Start Date'),
                  type: 'date',
                  required: true
                },
                {
                  key: 'toDate',
                  label: _vm.$t('End Date'),
                  type: 'date'
                },
                {
                  key: 'type',
                  label: _vm.$t('Type'),
                  type: 'select',
                  options: [
                    { label: _vm.$t('Conversions'), value: 'conversions' },
                    { label: _vm.$t('Emails'), value: 'emails' },
                    { label: _vm.$t('Form Responses'), value: 'formResponses' },
                    { label: _vm.$t('Transactions'), value: 'transactions' },
                    { label: _vm.$t('Scheduled Reports'), value: 'scheduled-report'}
                  ]
                },
                {
                  key: 'status',
                  label: _vm.$t('Status'),
                  type: 'select',
                  options: [
                    { label: _vm.$t('Started'), value: 'started' },
                    { label: _vm.$t('Processing'), value: 'background' },
                    { label: _vm.$t('Uploading'), value: 'uploading' },
                    { label: _vm.$t('Complete'), value: 'complete' },
                    { label: _vm.$t('Error'), value: 'error' }
                  ]
                }
              ],"shortcuts":[
                {
                  label: _vm.$t('Type'),
                  items: [
                    { label: _vm.$t('All'), onAction: function () { return _vm.setType(''); } },
                    { label: _vm.$t('Conversions'), onAction: function () { return _vm.setType('conversions'); } },
                    { label: _vm.$t('Emails'), onAction: function () { return _vm.setType('emails'); } },
                    { label: _vm.$t('Form Responses'), onAction: function () { return _vm.setType('formResponses'); } },
                    { label: _vm.$t('Transactions'), onAction: function () { return _vm.setType('transactions'); } }
                  ]
                }
              ],"applied-filters":_vm.filter,"query":false,"required":""},on:{"update":_vm.updateFilter}}),_c('DataTable',{attrs:{"columns":[
                {
                  key: 'type',
                  label: _vm.$t('Type')
                },
                {
                  key: 'statusNice',
                  label: _vm.$t('Status')
                },
                {
                  key: 'statusPercent',
                  label: _vm.$t('%')
                },
                {
                  key: 'details',
                  label: _vm.$t('Details')
                },
                {
                  key: 'createdOn',
                  label: _vm.$t('Created On'),
                  format: 'dateLong'
                },
                {
                  key: 'createdBy',
                  label: _vm.$t('Created By')
                },
                {
                  key: 'updatedOn',
                  label: _vm.$t('Updated On'),
                  format: 'dateLong'
                },
                {
                  key: 'updatedBy',
                  label: _vm.$t('Updated By')
                }
              ],"row-actions":function (row) { return _vm.getActions(row); },"rows":_vm.formattedDownloads,"loading":_vm.loadingState,"pagination":{
                offset: _vm.offset,
                limit: _vm.limit,
                total: _vm.totalElements,
                updateOffset: _vm.updateOffset,
                updateLimit: _vm.updateLimit
              }}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }